import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface OrganizationState {
  name: string;
}

const initialState: OrganizationState = {
  name: "MSC Energy",
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setOrganizationName(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
  },
});

export const { setOrganizationName } = organizationSlice.actions;
export default organizationSlice.reducer;
